module.exports = __webpack_public_path__ + "img/deal-svgrepo-com.2fc36ac4.svg";